(function () {
    'use strict';

    angular.module("imApp").factory("oeeStateLogService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 325,
                    parameters: parms || {}
                });
            },
            listStateLog: function (parms) {
                return $ihttp.post({
                    method: 257,
                    parameters: parms || {}
                });
            },
            approveItems: function (list) {
                return $ihttp.post({
                    method: 258,
                    parameters: list
                });
            }
        };

        return service;
    }]);
})();
